module.exports = __webpack_public_path__ + "static/media/searchIcon.22dd4b59.svg";